const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'Dropzone',
	DefaultRenderable: 'Dropzone-Display',
	CSS: /*css*/`
		.cst-dropzone
		{
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding: 60px 24px;
			border: 2px dashed var(--theme-color-border-default, #b0b6c2);
			border-radius: 12px;
			background: var(--theme-color-background-secondary, #f6f8fb);
			color: var(--theme-color-text-primary, #2c3140);
			margin: 24px;
			transition: background 0.15s, border-color 0.15s;
		}
		.cst-dropzone.cst-dropzone-active { background: var(--theme-color-background-hover, #eaf2ff); border-color: var(--theme-color-brand-primary, #4a7ad6); }
		.cst-dropzone-title { font-size: 22px; font-weight: 600; margin-bottom: 8px; }
		.cst-dropzone-hint  { font-size: 14px; color: var(--theme-color-text-secondary, #5b6376); margin-bottom: 18px; text-align: center; max-width: 540px; }
		.cst-dropzone-actions { display: flex; gap: 12px; flex-wrap: wrap; justify-content: center; }
		.cst-dropzone-btn
		{
			padding: 10px 18px;
			border-radius: 8px;
			background: var(--theme-color-text-primary, #2c3140);
			color: var(--theme-color-background-panel, #fff);
			cursor: pointer;
			font-weight: 500;
			border: none;
			font-size: 14px;
		}
		.cst-dropzone-btn-secondary { background: var(--theme-color-background-panel, #fff); color: var(--theme-color-text-primary, #2c3140); border: 1px solid var(--theme-color-border-default, #b0b6c2); }
		.cst-dropzone-error { color: var(--theme-color-status-error, #c0353a); margin-top: 14px; font-size: 13px; max-width: 540px; text-align: center; }
		.cst-dropzone-status { color: var(--theme-color-text-primary, #2c3140); margin-top: 14px; font-size: 14px; }
		.cst-dropzone input[type=file] { display: none; }
	`,
	Templates:
	[
		{
			Hash: 'Dropzone-Display',
			Template: /*html*/`
<div class="cst-dropzone" id="Dropzone-Root"
	ondragover="event.preventDefault(); this.classList.add('cst-dropzone-active');"
	ondragleave="this.classList.remove('cst-dropzone-active');"
	ondrop="event.preventDefault(); this.classList.remove('cst-dropzone-active'); _Pict.views.Dropzone.handleDrop(event);">
	<div class="cst-dropzone-title">Drop a Claude Code export</div>
	<div class="cst-dropzone-hint">{~D:AppData.Dropzone.HintText~}</div>
	<div class="cst-dropzone-actions">
		<button class="cst-dropzone-btn" onclick="_Pict.views.Dropzone.openFilePicker()">Choose file…</button>
		<button class="cst-dropzone-btn cst-dropzone-btn-secondary" onclick="_Pict.views.Dropzone.openFolderPicker()">Choose folder…</button>
	</div>
	<input type="file" id="Dropzone-FileInput"
		accept=".zip,.jsonl"
		onchange="_Pict.views.Dropzone.handleFileInput(event)" />
	<input type="file" id="Dropzone-FolderInput"
		webkitdirectory directory multiple
		onchange="_Pict.views.Dropzone.handleFileInput(event)" />
	<div class="cst-dropzone-status" id="Dropzone-Status">{~D:AppData.Dropzone.Status~}</div>
	<div class="cst-dropzone-error" id="Dropzone-Error">{~D:AppData.Dropzone.Error~}</div>
</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Dropzone-Display',
			TemplateHash:   'Dropzone-Display',
			ContentDestinationAddress: '#ClaudeTransformer-Workspace'
		}
	]
};

class PictViewDropzone extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.pict.AppData.Dropzone = this.pict.AppData.Dropzone || { Status: '', Error: '', HintText: '' };
	}

	onBeforeRender(pRenderable)
	{
		let tmpAuth = this.pict.AppData.Auth;
		if (tmpAuth && tmpAuth.LoggedIn)
		{
			this.pict.AppData.Dropzone.HintText = 'Drag in the .zip from /export. We\'ll parse it, save it to your account, and add it to your calendar.';
		}
		else
		{
			this.pict.AppData.Dropzone.HintText = 'Drag in the .zip from /export, or just the .jsonl, or the whole expanded export folder. Everything is parsed locally in your browser — nothing is uploaded.';
		}
		return super.onBeforeRender(pRenderable);
	}

	openFilePicker()
	{
		let tmpInput = document.getElementById('Dropzone-FileInput');
		if (tmpInput) tmpInput.click();
	}

	openFolderPicker()
	{
		let tmpInput = document.getElementById('Dropzone-FolderInput');
		if (tmpInput) tmpInput.click();
	}

	handleFileInput(pEvent)
	{
		let tmpFiles = pEvent && pEvent.target && pEvent.target.files;
		if (!tmpFiles || !tmpFiles.length) return;
		this._parse(tmpFiles);
	}

	handleDrop(pEvent)
	{
		let tmpDt = pEvent.dataTransfer;
		if (!tmpDt) return;
		// If the drop has items with directory entries, walk them; otherwise just use .files.
		if (tmpDt.items && tmpDt.items.length && tmpDt.items[0].webkitGetAsEntry)
		{
			let tmpEntries = [];
			for (let i = 0; i < tmpDt.items.length; i++)
			{
				let tmpEntry = tmpDt.items[i].webkitGetAsEntry();
				if (tmpEntry) tmpEntries.push(tmpEntry);
			}
			if (tmpEntries.some((pE) => pE.isDirectory))
			{
				return this._walkEntries(tmpEntries, (pErr, pFiles) =>
				{
					if (pErr) return this._setError(pErr.message);
					this._parse(pFiles);
				});
			}
		}
		this._parse(tmpDt.files);
	}

	_parse(pFiles)
	{
		this.pict.AppData.Dropzone.Status = 'Parsing ' + pFiles.length + ' file(s)…';
		this.pict.AppData.Dropzone.Error = '';
		this.render();
		let tmpParser = this.pict.providers.SessionParser;

		// Hold onto the raw zip file (if any) so that, on a logged-in upload
		// path, we can ship it to the server without re-reading from disk.
		let tmpFilesArr = Array.from(pFiles || []);
		let tmpZipFile = null;
		if (tmpFilesArr.length === 1 && /\.zip$/i.test(tmpFilesArr[0].name))
		{
			tmpZipFile = tmpFilesArr[0];
		}

		tmpParser.parseFiles(pFiles, (pErr, pSession) =>
		{
			if (pErr)
			{
				this._setError(pErr.message || String(pErr));
				return;
			}
			this.pict.AppData.Dropzone.Status = 'Loaded: ' + (pSession.Meta.title || pSession.Meta.sessionId);
			this.pict.AppData.Dropzone.Error = '';
			this.render();

			let tmpAuth = this.pict.AppData.Auth;
			let tmpCanUpload = !!(tmpAuth && tmpAuth.LoggedIn && tmpZipFile && this.pict.providers.SessionAPI);
			if (tmpCanUpload)
			{
				this._uploadSession(pSession, tmpZipFile);
				return;
			}

			let tmpApp = this.pict.PictApplication;
			if (tmpApp && typeof tmpApp.onSessionLoaded === 'function')
			{
				tmpApp.onSessionLoaded(pSession);
			}
		});
	}

	_uploadSession(pSession, pZipFile)
	{
		this.pict.AppData.Dropzone.Status = 'Uploading to your account…';
		this.render();
		let tmpMeta = pSession.Meta || {};
		let tmpStats = pSession.Stats || {};
		let tmpToISO = (pMs) =>
		{
			if (!pMs) return '';
			try { return new Date(pMs).toISOString(); } catch (e) { return ''; }
		};
		let tmpPayload =
			{
				Title: tmpMeta.title || pZipFile.name,
				OriginalFileName: pZipFile.name,
				FileSizeBytes: pZipFile.size || 0,
				SessionStartedAt: tmpToISO(tmpMeta.createdAt),
				SessionLastActivityAt: tmpToISO(tmpMeta.lastActivityAt),
				TotalDurationMs: tmpStats.totalDurationMs || 0,
				PromptCount: tmpStats.promptCount || 0,
				ToolCallCount: tmpStats.toolCallCount || 0,
				AgentCount: tmpStats.agentCount || 0,
				Model: tmpMeta.model || ''
			};

		this.pict.providers.SessionAPI.uploadSession(tmpPayload, pZipFile).then(() =>
		{
			this.pict.AppData.Dropzone.Status = '';
			this.render();
			let tmpApp = this.pict.PictApplication;
			if (tmpApp && typeof tmpApp.showSessions === 'function')
			{
				tmpApp.showSessions();
			}
		}).catch((pErr) =>
		{
			this._setError('Upload failed: ' + (pErr.message || pErr));
			let tmpApp = this.pict.PictApplication;
			if (tmpApp && typeof tmpApp.onSessionLoaded === 'function')
			{
				tmpApp.onSessionLoaded(pSession);
			}
		});
	}

	_setError(pMessage)
	{
		this.pict.AppData.Dropzone.Status = '';
		this.pict.AppData.Dropzone.Error = pMessage;
		this.render();
	}

	_walkEntries(pEntries, fCallback)
	{
		let tmpFiles = [];
		let tmpPending = 0;
		let tmpDone = false;

		let tmpFinish = (pErr) =>
		{
			if (tmpDone) return;
			tmpDone = true;
			fCallback(pErr, tmpFiles);
		};

		let tmpVisit = (pEntry, pPath) =>
		{
			if (pEntry.isFile)
			{
				tmpPending++;
				pEntry.file((pFile) =>
				{
					try { Object.defineProperty(pFile, 'webkitRelativePath', { value: pPath + pFile.name }); } catch(e){}
					tmpFiles.push(pFile);
					tmpPending--;
					if (tmpPending === 0) tmpFinish(null);
				}, (pErr) =>
				{
					tmpPending--;
					if (tmpPending === 0) tmpFinish(pErr);
				});
			}
			else if (pEntry.isDirectory)
			{
				let tmpReader = pEntry.createReader();
				let tmpReadBatch = () =>
				{
					tmpPending++;
					tmpReader.readEntries((pBatch) =>
					{
						if (!pBatch.length)
						{
							tmpPending--;
							if (tmpPending === 0) tmpFinish(null);
							return;
						}
						for (let i = 0; i < pBatch.length; i++)
						{
							tmpVisit(pBatch[i], pPath + pEntry.name + '/');
						}
						tmpPending--;
						tmpReadBatch();
					});
				};
				tmpReadBatch();
			}
		};

		for (let i = 0; i < pEntries.length; i++) tmpVisit(pEntries[i], '');
		if (tmpPending === 0) tmpFinish(null);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictViewDropzone;
module.exports.default_configuration = _ViewConfiguration;
